import { render, staticRenderFns } from "./ImAutoReply.vue?vue&type=template&id=494cb1a5&scoped=true"
import script from "./ImAutoReply.vue?vue&type=script&lang=js"
export * from "./ImAutoReply.vue?vue&type=script&lang=js"
import style0 from "./ImAutoReply.vue?vue&type=style&index=0&id=494cb1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494cb1a5",
  null
  
)

export default component.exports